export const ICONS = {
  'star-outlined': '\\e920',
  'star-filled': '\\e921',
  checkmark: '\\e922',
  'send-outlined': '\\e923',
  'send-filled': '\\e924',
  'orderarrived-outlined': '\\e925',
  'orderarrived-filled': '\\e926',
  'menu-outlined': '\\e927',
  'menu-filled': '\\e928',
  'food-outlined': '\\e929',
  'food-filled': '\\e92a',
  'close-outlined': '\\e92b',
  'close-filled': '\\e92c',
  'card-outlined': '\\e92d',
  'card-filled': '\\e92e',
  'call-outlined': '\\e92f',
  'call-filled': '\\e930',
  'calendar-edit-outlined': '\\e931',
  'calendar-hour-filled': '\\e932',
  'calendar-filled': '\\e933',
  'calendar-edit-filled': '\\e934',
  'calendar-hour-outlined': '\\e935',
  'calendar-outlined': '\\e936',
  'arrow-withtale-down': '\\e937',
  'arrow-left': '\\e938',
  'arrow-right': '\\e939',
  'arrow-up': '\\e93a',
  'arrow-down': '\\e93b',
  'arrow-withtale-left': '\\e93c',
  'arrow-withtale-right': '\\e93d',
  'arrow-withtale-up': '\\e93e',
  'walk-filled': '\\e900',
  'walk-outlined': '\\e901',
  'user-outlined': '\\e902',
  'user-group-filled': '\\e903',
  'user-filled': '\\e904',
  'user-group-outlined': '\\e905',
  'support-outlined': '\\e906',
  'support-filled': '\\e907',
  'store-outlined': '\\e908',
  'store-filled': '\\e909',
  'receipt-outlined': '\\e90a',
  'receipt-filled': '\\e90b',
  plus: '\\e90c',
  minus: '\\e90d',
  'order-outlined': '\\e90e',
  'order-filled': '\\e90f',
  'motor-filled': '\\e910',
  'motor-outlined': '\\e911',
  'logout-outlined': '\\e912',
  'logout-filled': '\\e913',
  'login-outlined': '\\e914',
  'login-filled': '\\e915',
  'location-outlined': '\\e916',
  'location-filled': '\\e917',
  'home-outlined': '\\e918',
  'home-filled': '\\e919',
  'gift-outlined': '\\e91a',
  'gift-filled': '\\e91b',
  'edit-outlined': '\\e91c',
  'edit-filled': '\\e91d',
  'cart-outlined': '\\e91e',
  'cart-filled': '\\e91f',
  // New icons added below
  'search-outlined': '\\e93f',
  'search-filled': '\\e940',
  'locationpin-outlined': '\\e941',
  'locationpin-filled': '\\e942',
  'clock-outlined': '\\e943',
  'clock-filled': '\\e944',
  'aim-outlined': '\\e945',
  'aim-filled': '\\e946',
  'trash-outlined': '\\e947',
  'trash-filled': '\\e948',
  'locationmap-outlined': '\\e949',
  'locationmap-filled': '\\e94a',
  'dollar-outlined': '\\e94b',
  'email-filled': '\\e94c',
  'email-outlined': '\\e94d',
  'completeprofile-outlined': '\\e94f',
  'completeprofile-filled': '\\e94e',
};
